import API from "./baseApi";

const login = (payload) => {
  return API.post("/auth/login", payload);
};

const loginOTP = (payload) => {
  return API.post("/auth/loginOTP", payload, {
    headers: {
      "Content-Type": "application/json",
      "x-tenant-id": "hdfc"
    }
  });
};

const logout = () => {
  return API.post("/auth/logout");
};

const getCurrentUser = () => {
  return API.post("/auth/me");
};

// Reset Password
const otpForResetPassword = (payload) => {
  return API.post(`/auth/otpForResetPassword`, payload, { headers: { 'Content-Type': 'application/json', "x-Tenant-Id": "hdfc" } });
};

const verifyOtp = (payload) => {
  return API.post(`/auth/verifyOtp`, payload);
};

const resetPassword = (payload) => {
  return API.post(`/auth/resetPassword`, payload);
};

const onboardingSetNewPassword = (userId, payload) => {
  return API.patch(`/users/onboarding-new-password/${userId}`, payload);
};


export default {
  login,
  loginOTP,
  logout,
  getCurrentUser,
  otpForResetPassword,
  verifyOtp,
  resetPassword,
  onboardingSetNewPassword
};
